import * as yup from 'yup';
import { error } from '../text';
import { userLimitMax, patternLimitMax, masterRecordLimitMax } from '../../constants/enum';

const emailValidation = yup
  .string()
  .lowercase()
  .required(error.required)
  .email(error.email)
  .max(250, error.below250);

const requiredValidation = yup.string().required(error.required);

const phoneNumberValidation = yup
  .string()
  .required(error.required)
  .matches(/^[0-9-]*$/, error.tel)
  .max(20, error.below20);

export const companyInviteSchema = yup.object().shape({
  companyName: requiredValidation.max(250, error.below250),
  userName: requiredValidation.max(250, error.below250),
  email: emailValidation,
});

export const companyEditSchema = yup.object().shape({
  companyName: requiredValidation.max(250, error.below250),
  phoneNumber: phoneNumberValidation,
});

export const userLimitChangeSchema = yup.object().shape({
  newLimit: yup
    .number()
    .typeError('担当者数は整数で入力してください')
    .required('変更後担当者数を入力してください')
    .integer('担当者数は整数で入力してください')
    .min(1, `担当者数は1〜${userLimitMax}の範囲で入力してください`)
    .max(userLimitMax, `担当者数は1〜${userLimitMax}の範囲で入力してください`),
  note: yup.string().required('備考を入力してください').max(2000, error.below2000),
});

export const patternLimitChangeSchema = yup.object().shape({
  newLimit: yup
    .number()
    .typeError('読取パターン数は整数で入力してください')
    .required('変更後読取パターン数を入力してください')
    .integer('読取パターン数は整数で入力してください')
    .min(1, `読取パターン数は1〜${patternLimitMax}の範囲で入力してください`)
    .max(patternLimitMax, `読取パターン数は1〜${patternLimitMax}の範囲で入力してください`),
  note: yup.string().required('備考を入力してください').max(2000, error.below2000),
});

export const masterRecordLimitChangeSchema = yup.object().shape({
  newLimit: yup
    .number()
    .typeError('レコード数は整数で入力してください')
    .required('変更後レコード数上限を入力してください')
    .integer('レコード数は整数で入力してください')
    .min(1, `レコード数は1〜${masterRecordLimitMax}の範囲で入力してください`)
    .max(masterRecordLimitMax, `レコード数は1〜${masterRecordLimitMax}の範囲で入力してください`),
  note: yup.string().required('備考を入力してください').max(2000, error.below2000),
});

export const companyPlanChangeSchema = yup.object().shape({
  plan: yup.number().required(error.required).min(0).max(3),
  paymentCycle: yup.number().when('plan', {
    is: (plan: number) => plan > 0,
    then: schema => schema.required('支払いサイクルを選択してください').oneOf([1, 2]),
    otherwise: schema => schema.optional(),
  }),
  paymentMethodValue: yup.number().when('plan', {
    is: (plan: number) => plan > 0,
    then: schema => schema.required('支払い方法を選択してください').oneOf([1, 2]),
    otherwise: schema => schema.optional(),
  }),
  note: yup.string().max(2000, error.below2000),
});
